import * as Sentry from '@sentry/nextjs';

/**
 * Client-side migration telemetry.
 * See monorep/docs/verification-environment.md § 3.2.
 *
 * Tag naming: area:detail  (e.g. "image-loader", "react-version", "mw:abtest")
 *
 * Behavior:
 *   dev or NEXT_PUBLIC_MIGRATE_LOG=1 → console.log('[migrate:<tag>]', payload)
 *   prod (default)                  → Sentry.addBreadcrumb({ category:'migrate', ... })
 */

type Payload = Record<string, unknown>;

const shouldConsoleLog = (): boolean => {
  if (process.env.NEXT_PUBLIC_MIGRATE_LOG === '1') return true;
  return process.env.NODE_ENV !== 'production';
};

export function migrateLog(tag: string, payload: Payload = {}): void {
  if (shouldConsoleLog()) {
    // Prefix is grep-able; full form in .verify logs
    // eslint-disable-next-line no-console
    console.log(`[migrate:${tag}]`, payload);
    return;
  }

  try {
    Sentry.addBreadcrumb({
      category: 'migrate',
      message: tag,
      level: 'info',
      data: payload,
    });
  } catch {
    // Sentry optional — never let telemetry break the page
  }
}

export default migrateLog;
